import Alpine from "alpinejs";

document.addEventListener('alpine:init', () => {
    Alpine.data('auRatingWidget', () => ({
        rating: null,
        score: 0,

        ratingMap: {
              'Super pris': 5,
              'God pris': 4,
              'Fair pris': 3,
              'Lidt for dyr': 2,
              'Dyr': 1
        },

        init() {
              const checkForIframe = setInterval(() => {
                    const container = document.querySelector('.au-widget-car-rating');
                    const iframe = container?.querySelector('iframe');

                    if (iframe?.srcdoc) {
                          const parser = new DOMParser();
                          const doc = parser.parseFromString(iframe.srcdoc, 'text/html');
                          const valueSpan = doc.querySelector('.score-label-light--label');

                          if (valueSpan) {
                                const text = valueSpan.textContent.trim();
                                this.rating = text;
                                this.score = this.ratingMap[text] || 0;
                                clearInterval(checkForIframe);
                            }
                    }
              }, 200);
        }
  }))
})